
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function SelectFormName(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const { selectedFormInfo } = props;
    return (
        <div className='header-form-name'>
            {tr('フォーマット:')}  {trLabel(Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, selectedFormInfo.name))}
        </div>
    );
}